// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__5dqG2","error":"Textarea_error__2ij6-","readonly":"Textarea_readonly__QG1ok","disabled":"Textarea_disabled__3zzNK"};